// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"styles/variables.css\"","second-table-shrink-width":"1250px","pageBody":"PageBody_pageBody__8UoLA","contentContainer":"PageBody_contentContainer__sO11F"};